export default function(data, title, location) {
    const state = Object.assign({isTriggeredFromCode: true}, data);
    history.replaceState(state, title, location);
}